module.exports = __webpack_public_path__ + "media/images/front/pc/default/noimage_s397x212-565f23fb58063de68bde11321e0ad11e.png";